import { TextField } from '@material-ui/core';
import React from 'react';

export function TextFieldWithLabel(props) {
  return <TextField {...props} variant="outlined" label={props.placeholder} autoComplete="off" fullWidth />;
}
